/**
 * 撤稿管理服务
 * 2019-7-2
 * Bai.Zhiming
 */
angular.module("withdrawalMgtServiceModule", [
    "withdrawalMgtDetailModule"
]).
factory("withdrawalMgtService", ["$modal", "$q", function($modal, $q) {
    return {
        /**
         * [detail description] 进入详情
         * @param  {[type]} item [description] 稿件信息
         * @return {[type]}      [description]
         */
        detail(item) {
            var defer = $q.defer();
            var modalInstance = $modal.open({
                templateUrl: "./editingCenter/iWo/withdrawalMgt/services/detail/detail_tpl.html",
                windowClass: 'withdrawalmgt_detail',
                backdrop: false,
                controller: "withdrawalMgtDetailCtrl",
                resolve: {
                    info() {
                        return item;
                    }
                }
            });
            //关闭弹窗
            modalInstance.result.then(function(result) {
                defer.resolve(result);
            }, function() {
                defer.reject("cancel");
            });
            return defer.promise;
        }
    };
}]);